import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AsReportedSecurityBreakdownTags } from "src/api/models";

@Component({
  selector: "app-edit-security-tag",
  // imports: [],
  templateUrl: "./edit-security-tag.component.html",
  styleUrl: "./edit-security-tag.component.css",
  standalone: false,
})
export class EditSecurityTagComponent {
  tagOptions = [
    { label: "is_award_related", key: "awardRelated", disable: false },
    { label: "is_options_related", key: "optionsRelated", disable: false },
    { label: "is_gift_related", key: "giftRelated", disable: false },
    { label: "is_tax_withheld", key: "taxWithheld", disable: false },
    { label: "is_remuneration", key: "remuneration", disable: false },
    { label: "is_indeterminable", key: "isIndeterminable", disable: false },
    { label: "is_sell_to_cover_/_net_settlement", key: "sellToCover", disable: false },

  ];
  selectedTags: any[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.selectedTags = [];

    if (config.data?.existingTags) {
      this.selectedTags = this.tagOptions.filter(
        (option) => config.data.existingTags[option.key] === true
      );
    }
    this.onTagSelection();
  }

  onEdit() {
    const tagObj: Partial<AsReportedSecurityBreakdownTags> = {};
    this.tagOptions.forEach((tag) => {
      (tagObj as Record<string, boolean>)[tag.key] =
        this.selectedTags.find((selected) => selected.key === tag.key) !=
        undefined;
    });
     //  FINAL SAFETY: BUY me sellToCover kabhi true na jaye
  if (this.config.data?.transactionType === 'BUY') {
    delete (tagObj as any).sellToCover; // ya (tagObj as any).sellToCover = false;
  }
    this.ref.close(tagObj);
  }

  onCancel() {
    this.ref.close();
  }

  // onTagSelection() {
  //   let selection = this.selectedTags;
    
  //   if (
  //     selection.length === 0 ||
  //     (selection.length === 1 && selection[0].key === "taxWithheld")
  //   ) {
  //     this.tagOptions.forEach((tag) => {
  //       tag.disable = false;
  //     });
  //     return;
  //   }
  //   selection.forEach((value) => {
  //     if (value.key === "remuneration" || value.key === "giftRelated") {
  //       this.selectedTags = [value];
  //       this.tagOptions.forEach((tag) => {
  //         if (tag.key !== value.key) {
  //           tag.disable = true;
  //         }
  //       });
  //     } else if (value.key === "optionsRelated") {
  //       this.selectedTags = this.selectedTags.filter(
  //         (tag) => tag.key !== "awardRelated"
  //       );
  //       this.tagOptions.forEach((tag) => {
  //         if (tag.key !== value.key && tag.key === "awardRelated") {
  //           tag.disable = true;
  //         }
  //       });
  //     } else if (value.key === "awardRelated") {
  //       this.selectedTags = this.selectedTags.filter(
  //         (tag) => tag.key !== "optionsRelated"
  //       );
  //       this.tagOptions.forEach((tag) => {
  //         if (tag.key !== value.key && tag.key === "optionsRelated") {
  //           tag.disable = true;
  //         }
  //       });
  //     }
  //   });
  // }
  onTagSelection() {
  let selection = this.selectedTags;

  // 1) Sab ko pehle enable kar do
  this.tagOptions.forEach((tag) => (tag.disable = false));

  // 2) Existing rules (remuneration / gift / award / options)
  if (
    selection.length !== 0 &&
    !(selection.length === 1 && selection[0].key === "taxWithheld")
  ) {
    selection.forEach((value) => {
      if (value.key === "remuneration" || value.key === "giftRelated") {
        this.selectedTags = [value];
        this.tagOptions.forEach((tag) => {
          if (tag.key !== value.key) {
            tag.disable = true;
          }
        });
      } else if (value.key === "optionsRelated") {
        this.selectedTags = this.selectedTags.filter(
          (tag) => tag.key !== "awardRelated"
        );
        this.tagOptions.forEach((tag) => {
          if (tag.key !== value.key && tag.key === "awardRelated") {
            tag.disable = true;
          }
        });
      } else if (value.key === "awardRelated") {
        this.selectedTags = this.selectedTags.filter(
          (tag) => tag.key !== "optionsRelated"
        );
        this.tagOptions.forEach((tag) => {
          if (tag.key !== value.key && tag.key === "optionsRelated") {
            tag.disable = true;
          }
        });
      }
    });
  }

  // 3) NEW RULE: agar transactionType BUY hai to sellToCover disable + unselect
  const txType = this.config.data?.transactionType;

  if (txType === "BUY") {
    // disable option
    const sellToCoverOpt = this.tagOptions.find(
      (t) => t.key === "sellToCover"
    );
    if (sellToCoverOpt) {
      sellToCoverOpt.disable = true;
    }

    // agar pehle se selected hai to unselect kar do
    this.selectedTags = this.selectedTags.filter(
      (t) => t.key !== "sellToCover"
    );
  }
}

}
